import React from "react"
import { MainCP } from "../../../Components/Ministerio-conocimiento/Ministerio-conocimiento-v2/MainCP"

const ViewMinisterio: React.FC = () => <MainCP/>

export default ViewMinisterio